import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import Introduction from "./sections/Introduction";
import Units from "./sections/Units";
import Pillars from "./sections/Pillars";
import News from "./sections/News";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Mission />
      <Introduction />
      <Units />
      <Pillars />
      <News />
      <Footer />
    </div>;
}